import { useModal } from '@shared/model/useModal';

export const useEditScheduleModal = () => useModal('edit-schedule')